import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { TokenSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, TokensFilterSchema } from "../ea.schema.query";

const base = "tokens";
const tokens = createEndpointBase(base);

export const tokensEndpoints = {
  tokensGet: tokens({
    method: "GET",
    path: "",
    request: z.object({ filter: TokensFilterSchema }).optional(),
    response: GetRequestBaseResponseSchema(TokenSchemas["general"].omit({ id: true, sso: true })),
    description: "Used to retrieve authentication tokens or the current user's API key list.",
  }),
  tokensCount: tokens({
    method: "GET",
    path: "count",
    request: z.object({ filter: TokensFilterSchema }).optional(),
    response: CountResponseSchema,
    description: "Used to retrieve the count of authentication tokens or API keys.",
  }),
  tokensCreate: tokens({
    method: "POST",
    path: "",
    request: TokenSchemas["create"],
    response: TokenSchemas["general"].omit({ sso: true }),
    description: "Creates a new entry in the security tokens or API keys category.",
  }),
  tokensUpdate: tokens({
    method: "PATCH",
    path: "",
    request: TokenSchemas["update"],
    response: TokenSchemas["general"].omit({ id: true, sso: true }),
    description: "Updates an existing record in the security tokens or API keys category.",
  }),
  tokensRegenerate: tokens({
    method: "PATCH",
    path: "regenerate",
    request: TokenSchemas["update"],
    response: TokenSchemas["general"].omit({ sso: true }),
    description: "Regenerates keys or values for the selected security tokens or API keys item.",
  }),
  tokensDelete: tokens({
    method: "POST",
    path: "delete",
    request: TokenSchemas["update"],
    response: z.any(),
    description:
      "Permanently deletes the specified item from the security tokens or API keys category.",
  }),
} as const;
